import { memo, useMemo } from 'react';

import Photo from '../Photo';

import type { Wws_PhotoItem } from '../../types/graphql';

const thumbnailDimensions = {
  width: 300,
  height: 300,
};

interface GalleryItemProps {
  index: number;
  photo: Wws_PhotoItem;
  photoItems: ReadonlyArray<Wws_PhotoItem>;
}

function GalleryItem({ index, photo, photoItems }: GalleryItemProps) {
  const { id: prevPhotoId } = photoItems[index - 1] || {};
  const { id: nextPhotoId } = photoItems[index + 1] || {};

  const { width, height, rotation, mediaUrl } = photo;

  let caption;

  const cropX = photo.cropX || 0;
  const cropY = photo.cropY || 0;

  const crop = `${cropX}.${cropY}.${cropX + width}.${cropY + height}`;

  const dimensions = useMemo<{
    width: number;
    height: number;
  }>(() => {
    return {
      width,
      height,
    };
  }, [height, width]);

  return (
    <Photo
      alt={`Gallery Photo ${index + 1}`}
      caption={caption}
      id={photo.id}
      crop={crop}
      nextPhotoId={nextPhotoId}
      path={mediaUrl || ''}
      prevPhotoId={prevPhotoId}
      rotation={rotation || 0}
      dimensions={dimensions}
      thumbnailDimensions={thumbnailDimensions}
    />
  );
}

export default memo(GalleryItem);
